/**
 * Parse raw transcript text into structured items.
 * Shared between LeadDetails and MeetingDetailPage.
 */
export const parseTranscriptText = (fullText) => {
  if (!fullText) return [];
  const lines = fullText.split(/\\n|\n/).filter(line => line.trim());
  return lines.map((line) => {
    const timestampMatch = line.match(/^\[(\d{2}:\d{2})\]\s*([^:]+):\s*(.+)$/);
    if (timestampMatch) {
      return { timestamp: timestampMatch[1], speaker: timestampMatch[2].trim(), text: timestampMatch[3].trim() };
    }
    const speakerMatch = line.match(/^([^:]+):\s*(.+)$/);
    if (speakerMatch) {
      return { timestamp: null, speaker: speakerMatch[1].trim(), text: speakerMatch[2].trim() };
    }
    return { timestamp: null, speaker: null, text: line.trim() };
  }).filter(item => item.text);
};

/**
 * Get available transcript sources from data
 * @param {object} transcriptData - Transcript response from API
 * @returns {Array} Array of available source names
 */
export const getAvailableSources = (transcriptData) => {
  const sources = [];

  if (transcriptData?.tldv?.full_text) sources.push('tldv');
  if (transcriptData?.fireflies?.full_text) sources.push('fireflies');
  if (transcriptData?.manual?.full_text) sources.push('manual');
  if (transcriptData?.recall?.full_text) sources.push('recall');

  // Fallback to sources_available from API
  if (sources.length === 0 && transcriptData?.sources_available) {
    return transcriptData.sources_available;
  }

  return sources;
};

/**
 * Determine primary source from consolidation metadata
 * @param {object} transcriptData - Transcript response from API
 * @returns {string} Primary source name
 */
export const getPrimarySource = (transcriptData) => {
  return transcriptData?.consolidation_metadata?.primary_source || 'consolidated';
};
